const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M39.392 3.776q-1.632 2.464-4.032 4.192 0.032 0.448 0.032 1.024 0 3.264-0.96 6.496-0.928 3.264-2.88 6.24-1.952 2.944-4.64 5.248t-6.432 3.648q-3.776 1.376-8.096 1.376-6.72 0-12.384-3.616 0.992 0.096 1.92 0.096 5.632 0 10.048-3.456-2.624-0.064-4.704-1.632-2.048-1.568-2.848-4 0.768 0.16 1.536 0.16 1.088 0 2.112-0.288-2.784-0.544-4.64-2.784-1.824-2.208-1.824-5.12v-0.128q1.696 0.96 3.648 1.024-1.664-1.088-2.624-2.88-0.96-1.76-0.96-3.84 0-2.176 1.088-4.064 3.040 3.744 7.36 5.952 4.32 2.24 9.28 2.496-0.192-0.896-0.192-1.856 0-3.328 2.368-5.696t5.696-2.368q3.52 0 5.92 2.56 2.72-0.544 5.12-1.984-0.928 2.912-3.552 4.48 2.432-0.288 4.64-1.28z"
});

const SvgTwitter = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-twitter",
    viewBox: "0 0 39 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter.cfcebd45.svg";
export { ForwardRef as ReactComponent };